<template>
  <img
    class="yellow_icon"
    :src="`${icon_path}${icon}`"
    alt="small icon">
</template>

<script>
export default {
  name: "YellowIcon",
  props: {
    icon: {
      type: String,
      default: ''
    },
    icon_path: {
      type: String,
      default: '/images/icons/'
    },
    alt: {
      type: String,
      default: 'small icon'
    }
  }
}
</script>
